// import {
// DATE_FORMAT
// } from 'src/utils/constants';
import { getMaxLengthErrorMsg } from 'src/utils/getInitials';
// import DATE_FORMAT from 'src/utils/constants';
import * as Yup from 'yup';

// vehicle form model
export const tyreFormModel = {
  formId: 'tyreConfig',
  formField: {
    tyre: {
      name: 'tyre_number',
      label: 'Tyre Number',
      requiredErrorMsg: 'Tyre Number is required',
      type: 'text',
      data: []
    },
    site: {
      name: 'site',
      label: 'Select Site',
      requiredErrorMsg: 'Site is required',
      type: 'select',
      data: []
    },
    travelled: {
      name: 'km_travelled',
      label: 'Km Travelled',
      requiredErrorMsg: 'Km Travelled is required',
      type: 'Date',
      data: []
    },
    figmentDate: {
      name: 'figment_date',
      label: 'Figment Date',
      // requiredErrorMsg: 'Vehicle Category is required',
      type: 'date',
      data: [],
      // data: new Date()
    },
    tyreBrand: {
      name: 'tyre_brand',
      label: 'Tyre Brand',
      requiredErrorMsg: 'Tyre Brand is required',
      // invalidErrorMsg: 'Registration Number is Invalid',
      type: 'text',
      data: []
    },
    purchaseDate: {
      name: 'purchase_date',
      label: 'Purchase Date',
      requiredErrorMsg: 'Purchase is required',
      invalidErrorMsg: 'Purchase is invalid',
      type: 'date',
      // data: [],
      // data: DATE_FORMAT.unixDate
    },
  }
};

// Initial values
const {
  formField: {
    site,
    tyre,
    travelled,
    figmentDate,
    tyreBrand,
    purchaseDate,
  }
} = tyreFormModel;

export const tyreFormInitialValues = {
  [tyre.name]: '',
  [site.name]: '',
  [travelled.name]: '',
  [figmentDate.name]: '',
  [tyreBrand.name]: '',
  [purchaseDate.name]: '',
};

// validation schema
export const tyreValidationSchema = Yup.object().shape({
  [site.name]: Yup.string().required(`${site.name} is required`),
  [tyre.name]: Yup.string().max(50, getMaxLengthErrorMsg(tyre, 50))
    .required(tyre.requiredErrorMsg),
  [travelled.name]: Yup.number().required(travelled.requiredErrorMsg)
    .typeError('Km Travelled must be a number'),
  [figmentDate.name]: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  [tyreBrand.name]: Yup.string().required(tyreBrand.requiredErrorMsg),
  [purchaseDate.name]: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
});
